import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './footnote.scss.js';

class Footnote extends s {
    render() {
        return $ `<div class="footnote-block"><slot name="head"></slot><slot name="body"></slot></div>`;
    }
}
Footnote.styles = css_248z;
customElements.define('footnote-block', Footnote);

export { Footnote };
